import { ResultProvider } from "./components/context/ResultContext";
import { DataProvider } from "./components/context/DataContext";
import { MediasizeProvider } from "./components/context/MediasizeContext";
import { RandomProvider } from "./components/context/RandomContext";
import { AttemptsProvider } from "./components/context/AttemptsContext";
import Content from './layout/Content/Content';
import './App.css';



function App() {
  return (
    <DataProvider>
        <MediasizeProvider>
          <RandomProvider>
            <ResultProvider>
              <AttemptsProvider>
                <Content />
              </AttemptsProvider>
            </ResultProvider>
          </RandomProvider>
        </MediasizeProvider>
    </DataProvider>
    
  );
}

export default App;
